import type { ReactElement } from "react";
import { Ctext } from "../Ctext";
import { TextPreset } from "@/constants/componentPresets";
import { FontWeight } from "@/theme/typography";
import { TOOLTIP_TEXT_OPACITY, TOOLTIP_TITLE_SIZE } from "./ctooltip-constants";

interface CtooltipTitleProps {
  title: string;
}

export function CtooltipTitle({ title }: CtooltipTitleProps): ReactElement {
  return (
    <Ctext
      preset={TextPreset.Accent}
      size={TOOLTIP_TITLE_SIZE}
      weight={FontWeight.Bold}
      opacity={TOOLTIP_TEXT_OPACITY}
    >
      {title}
    </Ctext>
  );
}
